import { recieveProjectTypes } from "./reducer";
import { APIClient } from "../../../helpers/api_helper";
const api = new APIClient();

export const loadProjectTypes = () => async (dispatch, getState) => {

    try {
        const data = await api.get('/api/project_types/get_options/')

        if (data) {
            dispatch(recieveProjectTypes(data));
        }
    } catch (error) {
        console.error('Unable to load project types!', error)
    }
};
